import { z } from 'zod';

export const UTM_SESSION_STORAGE_KEY = 'hr_utm_data';

export const UTM_PARAMS = {
  campaign: 'utm_campaign',
  medium: 'utm_medium',
  source: 'utm_source',
  term: 'utm_term',
  content: 'utm_content',
} as const;

export const UtmData = z.object({
  campaign: z.string().nullable(),
  source: z.string().nullable(),
  medium: z.string().nullable(),
  term: z.string().nullable(),
  content: z.string().nullable(),
});

export type UtmDataType = z.infer<typeof UtmData>;
